var _templateObject, _templateObject2, _templateObject3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/* eslint-disable react/no-array-index-key */

/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable react/require-default-props */
import React from 'react';
import { bool, node, string } from 'prop-types';
import styled from 'styled-components';
import CardText from './CardText';
import CardImage from './CardImage';
import CardTitle from './CardTitle'; // A grid container wraps entire card with 2 rows, 1 for image and 2 for all other content

var SharpCardWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: #FFFFFF;\n  box-sizing: border-box;\n  display: grid;\n  grid-template-rows: auto max-content;\n  grid-template-columns: minmax(0, 1fr);\n  border-radius: 5px;\n  &.borders {\n    border-bottom: 1px solid ", ";\n    border-top: 1px solid ", ";\n    border-right: 1px solid ", ";\n    border-left: 1px solid ", ";\n  }\n"])), function (props) {
  return props.borderColor || '#cfd8dc';
}, function (props) {
  return props.borderColor || '#cfd8dc';
}, function (props) {
  return props.borderColor || '#cfd8dc';
}, function (props) {
  return props.borderColor || '#cfd8dc';
});
SharpCardWrapper.displayName = 'SharpCardWrapper'; // A grid row which creates as many rows as required by the content in the card

var SharpCardContent = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-auto-rows: auto;\n  grid-template-columns: minmax(0, 1fr);\n  grid-row-gap: 1rem;\n  padding-bottom: 1rem;\n  padding-top: 1rem;\n"])));
SharpCardContent.displayName = 'SharpCardContent'; // A div to wrap each child passed in to Card

var SharpCardRow = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
SharpCardRow.displayName = 'SharpCardRow'; // Card component

var Card = function Card(_ref) {
  var borderColor = _ref.borderColor,
      _ref$borders = _ref.borders,
      borders = _ref$borders === void 0 ? false : _ref$borders,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      restProps = _objectWithoutProperties(_ref, ["borderColor", "borders", "children", "className"]);

  var cloneChildren = React.Children.toArray(children);
  var imageChild = [];
  var otherChildren = [];
  var withBorders = borders === true ? 'borders' : 'no-borders';
  var withBorderColor = borders === true ? borderColor : null; // All children except image are wrapped in container to provide padded section

  React.Children.map(cloneChildren, function (child, index) {
    if (child.type.displayName && child.type.displayName === 'CardImage') {
      imageChild.push( /*#__PURE__*/React.createElement(React.Fragment, null, child));
    } else {
      otherChildren.push( /*#__PURE__*/React.createElement(SharpCardRow, {
        key: "slc-card-text-".concat(index),
        className: "scl-card-row ".concat(className),
        "data-test-id": "scl-card-row"
      }, child));
    }
  });
  return /*#__PURE__*/React.createElement(SharpCardWrapper, _extends({
    borderColor: withBorderColor,
    className: "scl-card-wrapper ".concat(withBorders, " ").concat(className),
    "data-test-id": "scl-card-wrapper"
  }, restProps), /*#__PURE__*/React.createElement(React.Fragment, null, imageChild), /*#__PURE__*/React.createElement(SharpCardContent, {
    className: "scl-card-content ".concat(className),
    "data-test-id": "scl-card-content"
  }, otherChildren));
};

Card.Image = CardImage;
Card.Text = CardText;
Card.Title = CardTitle;
Card.Image.displayName = 'Card.Image';
Card.Text.displayName = 'Card.Text';
Card.Title.displayName = 'Card.Title';
Card.propTypes = {
  /**
   Adds borders to a card
   Make sure to pass in a borderColor prop if you add borders
  */
  borders: bool,

  /**
   Changes the color of Card border when borders are passed
   Default color is ''#cfd8dc'
  */
  borderColor: string,

  /**
   Everything included between opening and closing tags when invoking component
   */
  children: node.isRequired,

  /**
   Optional className to include in rendered component
  */
  className: string
};
export default Card;